export interface WebFonts {
     [fontName: string]: string;
}

export const availableFonts: WebFonts = {
     Lato: 'https://fonts.googleapis.com/css?family=Lato&display=swap',
     Merriweather: 'https://fonts.googleapis.com/css?family=Merriweather&display=swap',
     'Open Sans': 'https://fonts.googleapis.com/css?family=Open+Sans&display=swap',
     Roboto: 'https://fonts.googleapis.com/css?family=Roboto&display=swap'
};

export const ckFonts = [
  'Arial',
  'Calibri',
  'Comic Sans MS',
  'Courier New',
  'Georgia',
  'Helvetica',
  'Lucida Sans Unicode',
  'Lucida Grande',
  'Tahoma',
  'Geneva',
  'Times New Roman',
  'Times',
  'Trebuchet MS',
  'Verdana'
]
